// extracted by mini-css-extract-plugin
module.exports = {"cloud":"Step4CloudText_cloud__63jzT","paragraph":"Step4CloudText_paragraph__1lnVk"};